var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10468",
    "data-name": "Group 10468",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.719,
    height: 85.388,
    viewBox: "0 0 89.719 85.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4332",
    "data-name": "Rectangle 4332",
    width: 89.719,
    height: 85.388,
    fill: "#f77b00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44431",
    "data-name": "Path 44431",
    d: "M17.1,59.892c-2.417,0-4.707.1-6.984-.029A10.385,10.385,0,0,1,4.461,57.8,10.109,10.109,0,0,1,.044,49.412C.025,36.137-.068,22.86.094,9.587c.045-3.7,2.213-6.51,5.479-8.321A11.036,11.036,0,0,1,11.027,0Q38.4,0,65.771,0A10.765,10.765,0,0,1,76.634,8.546a12.956,12.956,0,0,1,.256,2.741q.024,18.512,0,37.025c-.009,3.227-.843,6.193-3.361,8.461a11.115,11.115,0,0,1-7.789,3c-9.574-.05-19.149-.009-28.723-.036a2.442,2.442,0,0,0-1.912.806c-3.539,3.584-7.111,7.136-10.674,10.7a4.227,4.227,0,0,1-6.987-1.269,4.38,4.38,0,0,1-.324-1.577c-.031-2.833-.015-5.666-.015-8.5m4.3,8.384c4.045-4.054,7.917-7.907,11.75-11.8a3.148,3.148,0,0,1,2.435-.994c10.242.019,20.484.03,30.725-.025a6.582,6.582,0,0,0,2.843-.77c2.618-1.342,3.5-3.7,3.5-6.5q0-17.913-.008-35.824c0-.725-.1-1.45-.141-2.175A6.23,6.23,0,0,0,66.078,4.28q-27.773-.072-55.546,0a6.233,6.233,0,0,0-6.256,6.443C4.3,23.5,4.326,36.275,4.257,49.05c-.018,3.3,2.87,6.537,6.278,6.454,2.6-.064,5.2-.009,7.806-.008,2.236,0,3.057.815,3.058,3.04,0,3.161,0,6.323,0,9.741",
    transform: "translate(0 0)",
    fill: "#f77b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44432",
    "data-name": "Path 44432",
    d: "M156.39,119.244c0-3.4.04-6.8-.021-10.2a2.245,2.245,0,0,1,2.37-2.368c2.668.032,5.344-.114,8,.04,3.238.187,6.622-2.771,6.619-5.945,0-.758.136-1.516.136-2.275q.014-17.961.006-35.921a6.96,6.96,0,0,0-2.341-5.6,15.47,15.47,0,0,1-1.473-1.119A2.1,2.1,0,0,1,169.7,53a2.366,2.366,0,0,1,2.733-.317,10.118,10.118,0,0,1,4.9,6.542,17.562,17.562,0,0,1,.406,3.8q.044,18.211.009,36.421c-.006,3.394-.952,6.45-3.614,8.756a10.066,10.066,0,0,1-6.29,2.684c-2.328.084-4.662.018-7.153.018,0,.419.005.767,0,1.114-.049,2.659-.069,5.32-.161,7.977a3.76,3.76,0,0,1-2.716,3.446,4.029,4.029,0,0,1-4.527-.894c-3.716-3.689-7.4-7.406-11.128-11.087a1.82,1.82,0,0,0-1.14-.507c-6.1-.032-12.208-.019-18.313-.025-1.37,0-1.938-.376-2.363-1.362a2.1,2.1,0,0,1,1.9-2.869c1.234-.019,2.468-.013,3.7-.014,5.371,0,10.741.013,16.112-.012a3.5,3.5,0,0,1,2.621,1.082q5.3,5.309,10.606,10.621c.307.308.577.651.865.978l.241-.111",
    transform: "translate(-88.045 -38.388)",
    fill: "#f77b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44433",
    "data-name": "Path 44433",
    d: "M115.264,70.03a8.374,8.374,0,0,1,4.455-7.764,5.452,5.452,0,0,0,2.139-7.822,5.159,5.159,0,0,0-4.983-2.331,4.909,4.909,0,0,0-4.6,4.048c-.372,1.546-1.071,2.209-2.193,2.325a2.208,2.208,0,0,1-2.2-2.616c.838-3.848,3.066-6.656,6.884-7.709a9.249,9.249,0,0,1,8.87,1.962,9.015,9.015,0,0,1,3.277,6.67,9.129,9.129,0,0,1-4.538,8.807,5.4,5.4,0,0,0-2.9,5.524,1.822,1.822,0,0,1-1.1,1.984,2.055,2.055,0,0,1-3.094-1.68c-.033-.464-.005-.933-.005-1.4",
    transform: "translate(-79.001 -35.002)",
    fill: "#f77b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44434",
    "data-name": "Path 44434",
    d: "M137.769,163.9a2.053,2.053,0,0,1-2.132-2,2.12,2.12,0,0,1,2.014-2.187,2.067,2.067,0,0,1,2.19,2.058,1.894,1.894,0,0,1-2.072,2.129",
    transform: "translate(-99.374 -117.015)",
    fill: "#f77b00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.b022adc315faf5c6328bb2323718ac7c.svg";
export { ForwardRef as ReactComponent };